<template></template>

<script>
import routers_admin from "@/app/admin/router.js";

export default {
  name: "APP_ADMIN",
  components: {
  },
  beforeCreate() {
    routers_admin.forEach((route) => {
      this.$router.addRoute(route);
    });
  },
};
</script>
